import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal, model, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { IftaLabelModule } from 'primeng/iftalabel';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FormsModule } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { CreateMeetingDialogComponent } from '../create-meeting-dialog/create-meeting-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { TenantOptionService } from '@/app/plateformebeneficiaire/core/service/tenantOption.service';
import { TenantOptionEnum } from '@/app/plateformebeneficiaire/core/models/enums/tenantOption.enum';

@Component({
  selector: 'app-meetings-box',
  imports: [
    FormsModule,
    CommonModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    StepsModule,
    StepperModule,
    SelectModule,
    IftaLabelModule,
    TableModule,
    PanelModule,
    ToggleButtonModule,
    ProgressSpinnerModule,
    ToastModule,
    CreateMeetingDialogComponent,
  ],
  templateUrl: './meetings-box.component.html',
  styleUrl: './meetings-box.component.scss',
  standalone: true,
})
export class MeetingsBoxComponent {
  constructor(private sanitizer: DomSanitizer) {}
  @ViewChild(CreateMeetingDialogComponent) createMeetingDialogchild!: CreateMeetingDialogComponent;

  meetingId: string | null = null;
  stepItem: number = 1;

  #tenantOptionService = inject(TenantOptionService);
  #tenantOptionsListQuery = this.#tenantOptionService.getListTenantOption();

  informations = computed(() =>
    this.sanitizer.bypassSecurityTrustHtml(
      this.getTenantOption(TenantOptionEnum.InformationsContactMeetingHomePage)
    )
  );
  
  displayModal: boolean = false;

  showModal() {
    this.displayModal = true;
  }

  hideModal() {
    this.displayModal = false;
  }

  onCreated(event: any) {
    this.displayModal = false;
  }

  onCancelled() {
    this.displayModal = false;
  }

  private getTenantOption(key: string): string {
    const options = this.#tenantOptionsListQuery.data() ?? [];
    return options.find((option) => option.key === key)?.value ?? '';
  }

  async updateMeeting(meeting: any) {
    this.createMeetingDialogchild.meetingId = meeting.id;

    if (await this.createMeetingDialogchild.siteExist(meeting.siteId)){
      this.createMeetingDialogchild.chooseSite(meeting.siteId);

      if (await this.createMeetingDialogchild.intervenantExist(meeting.intervenantId)){
        this.createMeetingDialogchild.chooseIntervenant(meeting.intervenantId);
  
        if (await this.createMeetingDialogchild.typeRdvExist(meeting.prestationId)){
          this.createMeetingDialogchild.chooseTypeRDV(meeting.prestationId);
          this.createMeetingDialogchild.stepItem.set(4);
        }
        else {
          this.createMeetingDialogchild.stepItem.set(3);
        }
      }
      else {
        this.createMeetingDialogchild.stepItem.set(2);
      }
    }
    else {
      this.createMeetingDialogchild.stepItem.set(1);
    }

    // const date = new Date(meeting.dateTimeDebut);
    // const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    // const formattedTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    // this.createMeetingDialogchild.chooseHoraire(formattedDate, formattedTime);

    this.showModal();
  }
}
